<div class="success-animation">
    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
    </svg>
</div>
<span class="subtitle">Setup Complete</span>
<span class="paragraph" style="margin-top:10px;">You've completed the StayPrivate setup.</span>
<!--span class="paragraph" style="margin-bottom:20px;"><span *ngIf="data.domain">All email accounts on {{data.domain}}</span> <span *ngIf="!data.domain">You</span> can now send encrypted emails, simply by including the keyword: <span class="sp-title sp-bold">{{data.keyword}}</span></span-->

<div *ngIf="data.tier != '120' && data.tier != '122' && data.tier != '124' && data.tier != '126'">
    <span class="paragraph">Any email account on {{data.domain}} can now send a private email simply by
        including the keyword: <span class="sp-title sp-bold">{{data.keyword}}</span> anywhere in the email.</span>
</div>
<div *ngIf="data.tier == '120'">
    <span class="paragraph">Any email account on {{data.domain}} can now deliver a document simply by
        including the keyword: <span class="sp-title sp-bold">#deliver</span> anywhere in the email.</span>
</div>
<div *ngIf="data.tier == '122'">
    <span class="paragraph" style="margin-bottom:20px;">Any email account on {{data.domain}} can send an email with
        documents to be signed simply by including the keyword: <span class="sp-title sp-bold">#sign</span> anywhere in the email.</span>
</div>
<div *ngIf="data.tier == '124'">
    <span class="paragraph">Any email account on {{data.domain}} can now send a private email simply by
        including the keyword: <span class="sp-title sp-bold">#private</span> anywhere in the email.</span>
    <span class="paragraph" style="margin-bottom:20px;">And any email account on {{data.domain}} can send an email with
        documents to be signed simply by including the keyword: <span class="sp-title sp-bold">#sign</span> anywhere in the email.</span>
</div>
<div *ngIf="data.tier == '126'">
    <!-- <span class="paragraph">All emails sent to an external domain will be checked and encrypted when TLS fails.</span> -->
    <span class="paragraph" style="margin-bottom:20px;">TLS Ensure checks all emails sent from {{data.domain}} to external domains and steps in where TLS fails, ensuring every email your business sends is encrypted and compliant with data protection regulations.
    </span>
</div>


<div mat-dialog-actions>
    <!-- <button mat-stroked-button class="cancel-button" (click)="dialogRef.close()">Cancel</button> -->
    <button mat-flat-button class="sp-background ok-button" color="primary"
        (click)="dialogRef.close(true)">Done</button>

</div>